export default {
  constructions: [],
  teams: [],
  posts: [],
};
